// Animate hero banner on scroll
function zoomimg() {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("animate");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
    }
  );
  $(".zoom-animation").each(function () {
    observer.observe(this);
  });
}
function contentanimation() {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("content-animate");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
    }
  );
  $(".content-visible").each(function () {
    observer.observe(this);
  });
}
let featureCardSlider = null;

function initFeatureCardSwiper() {
  featureCardSlider = new Swiper(".feature-card-slider-outer-wrap", {
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1919: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    navigation: {
      nextEl: ".feature-card-slider-outer-wrap .swiper-button-next",
      prevEl: ".feature-card-slider-outer-wrap .swiper-button-prev",
    },
  });
}
let threeCardSlider = null;

function initFeatureCardSwiperThreeCol() {
  threeCardSlider = new Swiper(".feature-card-slider-outer-wrap.three-col", {
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1919: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    navigation: {
      nextEl: ".feature-card-slider-outer-wrap.three-col .swiper-button-next",
      prevEl: ".feature-card-slider-outer-wrap.three-col .swiper-button-prev",
    },
  });
}
/* canvas images */
function productrotation() {
  const canvases = document.querySelectorAll(".product360Canvas");

  canvases.forEach((canvas) => {
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    const productNumber = canvas.dataset.product || "1";
    const frameCount = parseInt(canvas.dataset.framecount, 10) || 1;

    const images = [];
    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = `canvas-images/product${productNumber}/0_${i + 1}.webp`;
      images.push(img);
    }

    images[0].onload = function () {
      ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
    };

    function drawFrame(frameIndex) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(images[frameIndex], 0, 0, canvas.width, canvas.height);
    }

    canvas.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX;
    });

    canvas.addEventListener("mouseup", () => {
      isDragging = false;
    });

    canvas.addEventListener("mousemove", (e) => {
      if (!isDragging) return;

      let delta = e.pageX - startX;
      const sensitivity = 1;

      if (Math.abs(delta) > 1) {
        const framesToMove = Math.floor(Math.abs(delta) * sensitivity);

        currentFrame =
          delta > 0
            ? (currentFrame - framesToMove + frameCount) % frameCount
            : (currentFrame + framesToMove) % frameCount;

        drawFrame(currentFrame);
        startX = e.pageX;
      }
    });
  });
}

window.addEventListener("DOMContentLoaded", productrotation);

/* scroll section */
function updateActiveSection() {
  $(".scroll-section").each(function () {
    const sectionTop = $(this).offset().top;
    const sectionHeight = $(this).outerHeight();
    const scrollPosition = $(window).scrollTop();

    if (
      scrollPosition >= sectionTop - 190 &&
      scrollPosition < sectionTop + sectionHeight
    ) {
      const id = $(this).attr("id");
      $(".sidebar li").removeClass("active-slide");
      $('.sidebar li[data-target="#' + id + '"]').addClass("active-slide");
    }
  });
}
//for header dropdown menu
function menuDropdown() {
  if (window.innerWidth < 1024) {
    $(".navigations-wrapper").addClass("mobile-menu");
    $(
      ".navigations-wrapper.mobile-menu .mega-menu-links-wrapper .menu-category .inner-links"
    )
      .stop(true, true)
      .slideUp();

    $(
      ".navigations-wrapper.mobile-menu .mega-menu-links-wrapper .menu-category"
    ).removeClass("active");

    // Unbind any previous click handlers before adding new ones
    $(".mobile-menu .menu-category:has(.inner-links>a) a span.category-title")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        /* 8-12-25 - Menu banner content changes start */
        // if (window.innerWidth > 767) {
        //     $(".navigations-wrapper.mobile-menu .mega-menu-content").addClass(
        //         "show-image"
        //     );
        // }
        /* 8-12-25 - Menu banner content changes end */
        const parent = $(this).closest(".menu-category");
        const innerLinks = parent.find(".inner-links");

        $(this)
          .parents(".custom-megamenu-wrapper")
          .find(".menu-category")
          .not(parent)
          .removeClass("active");
        $(this)
          .parents(".custom-megamenu-wrapper")
          .find(".inner-links")
          .not(innerLinks)
          .slideUp();

        parent.toggleClass("active");
        innerLinks.stop(true, true).slideToggle();
      });
  } else {
    $(".navigations-wrapper").removeClass("mobile-menu");
    $(".navigations-wrapper .menu-category").removeClass("active");
    $(
      ".navigations-wrapper .mega-menu-links-wrapper .menu-category .inner-links"
    )
      .stop(true, true)
      .slideDown();
    $("html, body").removeClass("open-nav-menu");
  }
}
/* possition modal */
function positionModal($trigger, $modal) {
  const rect = $trigger[0].getBoundingClientRect();
  const modalHeight = $modal.outerHeight();
  const modalWidth = $modal.outerWidth();
  const viewportHeight = $(window).height();
  const viewportWidth = $(window).width();
  let top, left;
  const spaceBelow = viewportHeight - rect.bottom;
  const spaceAbove = rect.top;

  if (spaceBelow >= modalHeight + 10) {
    top = rect.bottom;
  } else if (spaceAbove >= modalHeight + 10) {
    top = rect.top - modalHeight;
  } else {
    top = rect.bottom;
  }
  if (viewportWidth < 767) {
    left = rect.left - 85;
  } else {
    left = rect.left - 110;
  }

  if (left + modalWidth > viewportWidth) {
    left = viewportWidth - modalWidth - 10;
  }

  if (left < 10) {
    left = 10;
  }

  $modal.css({
    top: top + "px",
    left: left + "px",
    position: "fixed",
  });
}

let badgeSwiper = null;

function initBadgeSwiper() {
    const swiperEl = document.querySelector(".badge-slider-section .swiper");
    if (!swiperEl) return;

    if (!swiperEl.swiper) {
        badgeSwiper = new Swiper(swiperEl, {
            // loop: true,
            slidesPerView: 1,
            spaceBetween: 40,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return `
                        <span class="${className}">
                            <svg viewBox="0 0 24 24" class="circle-ring">
                            <circle cx="12" cy="12" r="9" />
                            </svg>
                            <span class="dot"></span>
                        </span>
                    `;
                },
            },
            speed: 1000,
            autoplay: {
                delay: 7500,
                disableOnInteraction: false,
            },
        });
    }
}

/* 26-02-26 mobile search start */
function closeMobileMenu() {
  $("html, body").removeClass("open-nav-menu");
  headerWithAnnoucementUnified();
}
/* 26-02-26 mobile search end */

function customSearchExpand() {
  const searchInput = $(".header .search .field__input");
  const customSearchInput = $(
    ".header .custom-search-wrapper .search-input-wrapper input"
  );
  const searchButton = $(".header .search-action .search__button");

  function toggleSearchInput() {
    $("html, body").removeClass("open-nav-menu");
    $("body").addClass("search-input-expand");
    const searchOverlay = document.createElement("div");
    searchOverlay.classList.add("search-overlay");

    if ($(".search-overlay").length === 0) {
      document.body.appendChild(searchOverlay);
    }
    // make input focused
    customSearchInput.focus();
    searchOverlay.addEventListener("click", function () {
      $("body").removeClass("search-input-expand");
      searchOverlay.remove();
    });
    const closeBtn = $(".header .custom-search-wrapper .close-btn");
    closeBtn.on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("search-input-expand");
      searchOverlay.remove();
    });
  }

  if (searchInput.length && window.innerWidth >= 1280) {
    searchInput.on("focus", function () {
      toggleSearchInput();
    });
  }
  if (searchButton.length && window.innerWidth < 1280) {
    searchButton.on("click", function (e) {
      e.preventDefault();
      toggleSearchInput();
      closeMobileMenu();
    });
  }
}

/* 20-02-26 announcement bar start */
function headerWithAnnoucementUnified() {
  const $announcementBar = $(".announcement-bar:not(.is-hidden)");
  const $stickyBar = $(".announcement-bar.sticky-bar:not(.is-hidden)");
  const $header = $(".header .header__row");
  const $nav = $(".navigations-wrapper");
  const $megaMenu = $(".custom-megamenu-wrapper");
  const $productBar = $(".product-pagebar-wrapper");
  const $cardModal = $(".card-popup-modal");

  const isDesktop = window.innerWidth >= 1024;
  const scrollTop = $(window).scrollTop();

  const spacing = isDesktop ? 24 : 16;

  const announcementHeight = $announcementBar.length
    ? $announcementBar.innerHeight()
    : 0;
  const isSticky = $stickyBar.length > 0;

  const productBarVisible = scrollTop >= 650 && $productBar.length > 0;
  const productBarHeight = productBarVisible ? $productBar.innerHeight() : 0;

  /*HEADER POSITION */
  let headerTop = 0;

  if (isSticky) {
    headerTop = announcementHeight + spacing;

    if (productBarVisible) {
      headerTop += productBarHeight - (isDesktop ? 18 : 10);
    }

    $header.css({
      marginTop: 0,
      top: headerTop + "px",
    });
  } else {
    if (scrollTop < announcementHeight && announcementHeight > 0) {
      headerTop = announcementHeight + spacing;
    } else {
      headerTop = spacing;
    }

    if (productBarVisible) {
      headerTop += productBarHeight - (isDesktop ? 18 : 10);
    }

    $header.css({
      marginTop: headerTop + "px",
      top: 0,
    });
  }

  /* PDP PRODUCT BAR */
  if ($productBar.length) {
    if (productBarVisible) {
      $productBar.css({
        transform: "none",
        top: isSticky ? announcementHeight + "px" : "0px",
      });
    } else {
      $productBar.css({
        transform: "translateY(-100%)",
      });
    }
  }

  /* NAVIGATION POSITION */
  let navTop = 88;

  if (isSticky) {
    navTop += announcementHeight;
  } else if (scrollTop < announcementHeight && announcementHeight > 0) {
    navTop += announcementHeight;
  }

  if (productBarVisible) {
    navTop += productBarHeight - 19;
  }

  if (isDesktop) {
    $nav.css({
      top: navTop + "px",
      maxHeight: `calc(100dvh - ${navTop}px)`,
    });
  } else {
    $nav.css({
      top: "unset",
      maxHeight: "unset",
    });
  }

  /* MOBILE MENU POSITION */
  if (!isDesktop && $("body").hasClass("open-nav-menu")) {
    let menuTop = 79;

    if (isSticky) {
      menuTop += announcementHeight;
    } else if (scrollTop < announcementHeight && announcementHeight > 0) {
      menuTop += announcementHeight;
    }

    if (productBarVisible) {
      menuTop += productBarHeight - 12;
    }

    $megaMenu.css({
      top: menuTop + "px",
      height: `calc(100dvh - ${menuTop + 17}px)`,
    });
  } else {
    $megaMenu.css({
      top: 79,
      height: 0,
    });
  }

  /* SEARCH INPUT POSITION (MOBILE ONLY) */
  if (!isDesktop) {
    const $searchWrapper = $(".custom-search-wrapper");

    if ($searchWrapper.length && $("body").hasClass("search-input-expand")) {
      let searchTop = 98;

      if (isSticky) {
        searchTop = 98 + announcementHeight;

        if (productBarVisible) {
          searchTop += productBarHeight;
        }
      } else {
        if (scrollTop < announcementHeight && announcementHeight > 0) {
          searchTop = 98 + announcementHeight;
        }

        if (productBarVisible) {
          searchTop += productBarHeight;
        }
      }

      $searchWrapper.css("top", searchTop + "px");
    } else {
      $(".custom-search-wrapper").css("top", "98px");
    }
  }

  /* CARD POPUP MODAL POSITION */
  if ($cardModal.length) {
    let modalTop = 96;

    if (isSticky) {
      modalTop = 96 + announcementHeight;

      if (productBarVisible) {
        modalTop += productBarHeight;
      }
    } else {
      if (scrollTop < announcementHeight && announcementHeight > 0) {
        modalTop = 96 + announcementHeight;
      }

      if (productBarVisible) {
        modalTop += productBarHeight;
      }
    }

    $cardModal.css("top", modalTop + "px");
  }

  /* RESET (NO ANNOUNCEMENT, NO PDP) */
  if (!$announcementBar.length && !productBarVisible) {
    $header.css({
      marginTop: spacing + "px",
      top: 0,
    });

    if (isDesktop) {
      $nav.css({
        top: "88px",
        maxHeight: "calc(100dvh - 88px)",
      });
    }

    $cardModal.css("top", "96px");
  }
}

(function () {
  /* STRING HASH (FNV-1a) */
  function hashString(str) {
    let hash = 2166136261;
    for (let i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash +=
        (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return (hash >>> 0).toString(36);
  }

  /* SAFE STORAGE HELPERS */
  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {
      console.error(e);
    }
  }

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (e) {}
  }

  /* MAIN INITIALIZER */
  function initAnnouncementBars(root = document) {
    const bars = root.querySelectorAll(".announcement-bar");

    bars.forEach((bar) => {
      const sectionId = bar.dataset.sectionId;
      if (!sectionId) return;

      const mode = bar.dataset.dismissMode || "session";
      const hours = parseFloat(bar.dataset.dismissHours || "0");

      const slides = bar.querySelector(".announcement-bar__slides");
      const closeBtn = bar.querySelector("#announcement-close-button");

      /* CONTENT HASH (detect any change) */
      const content = slides ? slides.textContent.trim() : "";
      const contentHash = hashString(content);

      /* STORAGE KEYS (tiny footprint) */
      const base = `announcement_${sectionId}`;
      const modeKey = `${base}_mode`;
      const stateKey = `${base}_state`;
      const expiryKey = `${base}_expiry`;
      const hashKey = `${base}_hash`;

      /* RESET IF CONTENT CHANGED */
      const storedHash = safeGet(localStorage, hashKey);

      if (storedHash && storedHash !== contentHash) {
        safeRemove(localStorage, stateKey);
        safeRemove(localStorage, expiryKey);
        safeRemove(sessionStorage, stateKey);
      }

      safeSet(localStorage, hashKey, contentHash);

      /* RESET IF MODE CHANGED */
      const storedMode = safeGet(localStorage, modeKey);

      if (storedMode && storedMode !== mode) {
        safeRemove(localStorage, stateKey);
        safeRemove(localStorage, expiryKey);
        safeRemove(sessionStorage, stateKey);
      }

      safeSet(localStorage, modeKey, mode);

      /* SHOULD HIDE? */
      let shouldHide = false;

      if (mode === "session") {
        shouldHide = safeGet(sessionStorage, stateKey) === "hidden";
      }

      if (mode === "permanent") {
        shouldHide = safeGet(localStorage, stateKey) === "hidden";
      }

      if (mode === "time") {
        const expiry = safeGet(localStorage, expiryKey);
        if (expiry && Date.now() < parseInt(expiry, 10)) {
          shouldHide = true;
        }
      }

      /* SHOW BAR (no flicker) */
      if (!shouldHide) {
        bar.classList.remove("is-hidden");
      }

      /* NON DISMISSIBLE */
      if (!closeBtn || mode === "none") return;

      closeBtn.addEventListener("click", () => {
        bar.classList.add("is-hidden");

        headerWithAnnoucementUnified();

        if (mode === "session") {
          safeSet(sessionStorage, stateKey, "hidden");
        }

        if (mode === "permanent") {
          safeSet(localStorage, stateKey, "hidden");
        }

        if (mode === "time") {
          const expiryTime = Date.now() + hours * 60 * 60 * 1000;
          safeSet(localStorage, expiryKey, expiryTime.toString());
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAnnouncementBars();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initAnnouncementBars(event.target);
  });
})();
/* 20-02-26 announcement bar end */

/* 08-05-26 New Image Slider Start */
function initializePDPImageContentSlider() {

  const imageContentSliders = document.querySelectorAll(
    ".image-content-slider-section"
  );

  imageContentSliders.forEach((section, index) => {
    const slider = section.querySelector(
      ".image-content-slider-swiper"
    );

    const prevBtn = section.querySelector(
      ".slider-arrow-prev"
    );

    const nextBtn = section.querySelector(
      ".slider-arrow-next"
    );

    const pagination = section.querySelector(
      ".slider-pagination"
    );

    if (!slider || slider.classList.contains("swiper-initialized")) return;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 700,
      allowTouchMove: true,
      watchSlidesProgress: true,
      updateOnWindowResize: true,
      resizeObserver: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: false,
      on: {
        init: function () {
          updateArrows(this);
          section.classList.add("swiper-navigation-ready");
        },
        slideChange: function () {
          updateArrows(this);
        },
        resize: function () {
          this.update();
          updateArrows(this);
        },
      },
    });

    nextBtn.addEventListener("click", function () {
      if (swiper.isEnd) return;
      swiper.slideNext();
    });

    prevBtn.addEventListener("click", function () {
      if (swiper.isBeginning) return;
      swiper.slidePrev();
    });

    function updateArrows(swiperInstance) {
      if (swiperInstance.isBeginning) {
        prevBtn.classList.add("swiper-button-disabled");
      } else {
        prevBtn.classList.remove("swiper-button-disabled");
      }

      if (swiperInstance.isEnd) {
        nextBtn.classList.add("swiper-button-disabled");
      } else {
        nextBtn.classList.remove("swiper-button-disabled");
      }

    }
  });
}
/* 08-05-26 New Image Slider End */

/* enumeration block updates start */
/* 03-07-26: product card redesign start */
function eqHeight() {

    $.fn.extend({
        equalHeights: function () {

            var rows = {};

            // Reset height first
            $(this).css("height", "auto");

            $(this).each(function () {

                var $item = $(this);

                // Get the actual product grid item
                var $card = $item.closest(".product-list-card");

                // Use product card position to identify the row
                var rowTop = $card.length
                    ? Math.round($card.offset().top)
                    : Math.round($item.offset().top);

                if (!rows[rowTop]) {
                    rows[rowTop] = [];
                }

                rows[rowTop].push($item);
            });

            // Equal height for each actual product row
            $.each(rows, function (rowTop, items) {

                var maxHeight = 0;

                items.forEach(function ($item) {
                    var height = $item.outerHeight();

                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });

                if (maxHeight > 0) {
                    items.forEach(function ($item) {
                        $item.height(maxHeight);
                    });
                }

            });

            return this;
        }
    });

    $(".product-content:has(.product-enumeration) .product-title").equalHeights();
    $(".product-card-wrapper .details-wrapper").equalHeights();
    $(".product-card-wrapper .product-name.title-link").equalHeights();
    $(".product-card-wrapper .product-content-inner .product-top-wrapper").equalHeights();
    localizeEqualHeight();
    $("div.snize li.snize-product span.snize-title").equalHeights();
    $("#snize-search-results-grid-mode .snize-product .custom-content-wrapper").equalHeights();
}

function localizeEqualHeight() {

    var rows = {};

    var $items = $(".product-card-wrapper .localize-content-outer");

    // Reset height
    $items.css("height", "auto");


    $items.each(function () {

        var $item = $(this);

        var $card = $item.closest(".product-list-card");

        var rowTop = $card.length
            ? Math.round($card.offset().top)
            : Math.round($item.offset().top);


        if (!rows[rowTop]) {
            rows[rowTop] = [];
        }

        rows[rowTop].push($item);

    });


    // Calculate height row-wise
    $.each(rows, function (rowTop, items) {

        var maxHeight = 0;


        items.forEach(function ($item) {

            var height = $item.find(".localize-content").outerHeight(true);

            if (height > maxHeight) {
                maxHeight = height;
            }

        });


        if (maxHeight > 0) {

            items.forEach(function ($item) {
                $item.height(maxHeight);
            });

        }

    });
}

// Search result Infinite scrolling handling
document.addEventListener('DOMContentLoaded', () => {
  const resultsList = document.querySelector('results-list');
  const grid = resultsList?.querySelector('[ref="grid"]');

  if (!grid) return;

  let currentPage = Number(
    grid.querySelector('[ref="cards[]"]')?.dataset.page || 1
  );

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList' || !mutation.addedNodes.length) {
        continue;
      }

      const newCard = [...mutation.addedNodes].find(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches('[ref="cards[]"]')
      );

      if (!newCard) continue;

      const newPage = Number(newCard.dataset.page);

      if (newPage > currentPage) {
        currentPage = newPage;

        /* enumeration block updates start */
        eqHeight();
        /* enumeration block updates end */
      }
    }
  });

  observer.observe(grid, {
    childList: true,
  });
});
/* 03-07-26: product card redesign end */
/* enumeration block updates end */

$(window).on('load', function () {
    /* enumeration block updates start */
    setTimeout(() => {
        eqHeight();
    }, 500);
    /* enumeration block updates end */
    /* 20-02-26 announcement bar start */
    headerWithAnnoucementUnified()
    /* 20-02-26 announcement bar end */
});

$(document).ready(function () {

  /* 08-05-26 New Image Slider Start */
  initializePDPImageContentSlider()
  /* 08-05-26 New Image Slider End */

  /* 20-02-26 announcement bar start */
  headerWithAnnoucementUnified();
  /* 20-02-26 announcement bar end */

  /* enumeration block updates start */

  /* 03-07-26: product card redesign start */
  const observer = new MutationObserver(() => {
      if ($(".snize-product .custom-content-wrapper").length) {
          eqHeight();
      }
  });
  
  observer.observe(document.body, {
      childList: true,
      subtree: true
  });
  
  setTimeout(() => {
      eqHeight();
  }, 500);
  /* 03-07-26: product card redesign end */
  
  /* enumeration block updates end */

  initFeatureCardSwiper();

  // for header
  const header = $(".header");
  const navigationsWrap = $(".navigations-outer-wrap");
  setTimeout(() => {
    header.css("opacity", 1);
    navigationsWrap.css("opacity", 1);
  }, 700);
  setTimeout(() => {
    $(
      ".hero-banner-section .product-associated-list-wrap, .hero-banner-section .badge-wrapper"
    ).css("opacity", 1);
  }, 1200);
  menuDropdown();
  const menuBtn = $(".header .mobile-hamburger-wrapper");
  menuBtn.on("click", function () {
    /* 8-12-25 - Menu banner content changes start */
    // if ($(".navigations-wrapper.mobile-menu .mega-menu-content").length > 0) {
    //     $(".navigations-wrapper.mobile-menu .mega-menu-content").removeClass(
    //         "show-image"
    //     );
    // }
    /* 8-12-25 - Menu banner content changes end */
    $("html, body").toggleClass("open-nav-menu");

    if (window.pageSmoother) {
      window.pageSmoother.paused($("html").hasClass("open-nav-menu"));
    }

    /* 20-02-26 announcement bar start */
    headerWithAnnoucementUnified();
    /* 20-02-26 announcement bar end */
  });
  // for mega menu
  const navLinks = $(".header .navbar .main-nav-list li a");
    const outerWrap = $("#header-group");
    navLinks.on("mouseenter", function () {
        if($(this).hasClass("no-submenu")) {
            navLinks.removeClass("active");
            if (window.innerWidth > 1024) {
            $(this).removeClass("active");
            $("html, body").removeClass("open-nav-menu");
        }
        }
        else {
            navLinks.removeClass("active");
            $(this).addClass("active");
            var targetId = $(this).attr("data-id");
                  if ($(".navigations-outer-wrap[data-id='" + targetId + "']").length > 0) {
                $(".navigations-outer-wrap").removeClass("active");
                $(".navigations-outer-wrap[data-id='" + targetId + "']").addClass("active");
                $("html, body").addClass("open-nav-menu");
            }
        }
    });
  // const navLinks = $(".header .navbar .main-nav-list li a");
  // const outerWrap = $("#header-group");
  // navLinks.on("mouseenter", function () {
  //   navLinks.removeClass("active");
  //   $(this).addClass("active");
  //   var targetId = $(this).attr("data-id");
  //   if ($(".navigations-outer-wrap[data-id='" + targetId + "']").length > 0) {
  //     $(".navigations-outer-wrap").removeClass("active");
  //     $(".navigations-outer-wrap[data-id='" + targetId + "']").addClass(
  //       "active"
  //     );
  //     $("html, body").addClass("open-nav-menu");
  //   }
  // });
  outerWrap.on("mouseleave", function () {
    if (window.innerWidth > 1024) {
      $(this).removeClass("active");
      $("html, body").removeClass("open-nav-menu");
    }
  });

  $(".cart-drawer .header-actions__action").click(function () {
    $("html, body").removeClass("open-nav-menu");
  });

  // for search-expand
  customSearchExpand();

  // for filter wrapper
  const filterWrapper = $(".custom-filter-wrapper");
  const filterTabs = filterWrapper.find(".custom-tabs .tab");
  const filterContents = filterWrapper.find(".tab-content");
  filterTabs.off("click").on("click", function (e) {
    var tab_id = $(this).attr("data-tab");

    $(this).parents(".custom-filter-wrapper").find(".filter-btns .btn").hide();
    if (tab_id === "sort-by") {
      // if any radio input is checked in sort-by tab then clear btn shows
      if (
        $("#" + tab_id).find(
          ".filter-options .filter-checkbox input[type='radio']:checked"
        ).length > 0
      ) {
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".filter-btns .btn#clear-filter")
          .show();
      }
    } else {
      if (
        filterContents.find(
          ".filter-options .filter-checkbox input[type='checkbox']:checked"
        ).length > 0
      ) {
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".filter-btns .btn")
          .show();
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".filter-btns .btn#clear-filter")
          .hide();
      }
    }

    //remove hide-filter-btns class from filter buttons
    $(this)
      .parents(".custom-filter-wrapper")
      .find(".filter-btns")
      .removeClass("hide-filter-btns");
    if (window.innerWidth < 1024) {
      e.preventDefault();
      filterTabs.removeClass("current");
      filterContents.removeClass("current");
      filterContents.find(".filter-options").hide();
      $("body").addClass("open-filter-drawer");

      if (tab_id === "sort-by") {
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".tab-content")
          .removeClass("visible");
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".tab-content#sort-by, .tab-content#filters")
          .addClass("visible");
      } else {
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".tab-content")
          .addClass("visible");
        $(this)
          .parents(".custom-filter-wrapper")
          .find(".tab-content#sort-by")
          .removeClass("visible");
      }

      filterContents.each(function () {
        const $content = $(this);
        if ($content.find(".filter-options").length > 0) {
          $(this)
            .find(".title-block")
            .off("click")
            .on("click", function () {
              const options = $(this).next(".filter-options");
              filterContents.find(".filter-options").not(options).hide();
              const parentContent = $(this).closest(".tab-content");
              filterContents.not(parentContent).removeClass("active");

              if (options.is(":visible")) {
                options.hide();
                parentContent.removeClass("active");
              } else {
                options.show();
                parentContent.addClass("active");
              }
            });

          const checkBoxs = $content.find(".filter-options .filter-checkbox");
          checkBoxs.off("click").on("click", function () {
            const activeContent = filterContents.filter(".active");
            if (
              activeContent.length &&
              activeContent.attr("id").toLowerCase() === "sort-by"
            ) {
              $("body").removeClass("open-filter-drawer");
              filterContents.removeClass("active");
              filterContents.find(".filter-options").hide();
            }
          });
        }
      });

      const closeBtn = filterWrapper.find(".close-btn");
      closeBtn.on("click", function () {
        $("body").removeClass("open-filter-drawer");
        filterContents.removeClass("active");
        filterContents.find(".filter-options").hide();
      });
    } else {
      $("body").removeClass("open-filter-drawer");
      // if any checkbox is checked, add disabled class in sort-by tab
      const sortByTab = $(this)
        .closest(".custom-filter-wrapper")
        .find(".sort-by-tab");
      if (
        $("#" + tab_id)
          .find(".filter-options .filter-checkbox input[type='checkbox']")
          .filter(":checked").length > 0
      ) {
        sortByTab.addClass("disabled");
      }
    }
  });

  const sortByFilterOptions = $(
    ".custom-filter-wrapper .tab-content#sort-by .filter-options .filter-checkbox input"
  );
  if (sortByFilterOptions.length) {
    sortByFilterOptions.each(function () {
      $(this)
        .off("click")
        .on("click", function () {
          $(".custom-filter-wrapper .filter-btns").addClass("hide-filter-btns");
          $("body").removeClass("open-filter-drawer");
          const $wrapper = $(this).closest(".custom-filter-wrapper");
          $wrapper.find(".tab").removeClass("current active disabled");
          $wrapper.find(".tab-content").removeClass("current active");
        });
    });
  }

  const otherFilterOptions = $(
    ".custom-filter-wrapper .tab-content:not(#sort-by) .filter-options .filter-checkbox input"
  );
  if (otherFilterOptions.length) {
    otherFilterOptions.each(function () {
      // if input is checked remove hide-filter-btns class
      $(this)
        .off("click")
        .on("click", function () {
          const $wrapper = $(this).closest(".custom-filter-wrapper");
          if (
            $wrapper.find(
              ".tab-content:not(#sort-by) .filter-options .filter-checkbox input[type='checkbox']:checked"
            ).length > 0
          ) {
            $wrapper.find(".filter-btns").removeClass("hide-filter-btns");
            // show btns
            $wrapper.find(".filter-btns .btn").show();
            // hide clear filter btn
            $wrapper.find(".filter-btns .btn#clear-filter").hide();
          } else {
            $wrapper.find(".filter-btns").addClass("hide-filter-btns");
            // hide btns
            $wrapper.find(".filter-btns .btn").hide();
          }
        });
    });
  }

  const filterBtns = $(".custom-filter-wrapper .filter-btns .btn");
  if (filterBtns.length) {
    filterBtns.on("click", function () {
      $("body").removeClass("open-filter-drawer");
      $(this).parents(".filter-btns").addClass("hide-filter-btns");
      $(this)
        .parents(".custom-filter-wrapper")
        .find(".tab")
        .removeClass("current");
      $(this)
        .parents(".custom-filter-wrapper")
        .find(".tab")
        .removeClass("active");
      $(this)
        .parents(".custom-filter-wrapper")
        .find(".tab")
        .removeClass("disabled");
      $(this)
        .parents(".custom-filter-wrapper")
        .find(".tab-content")
        .removeClass("current");
      $(this)
        .parents(".custom-filter-wrapper")
        .find(".tab-content")
        .removeClass("active");
      $(this)
        .parents(".custom-filter-wrapper")
        .find(".tab-content")
        .removeClass("active");
    });
  }

  // back to top button
  const backToTopButton = $(".footer .back-to-top-btn");
  if (backToTopButton) {
    backToTopButton.on("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
  $(".video-wrapper .video-bg").on("click", function (e) {
    const wrapper = $(this).closest(".video-wrapper");
    wrapper.addClass("open");

    const video = wrapper.find("video").get(0); // get the DOM element
    if (video) {
      video.play().catch((err) => {
        console.error("Video play failed:", err);
      });
    }
  });

  // Faq
  $(".accordion-heading").click(function () {
    $(this)
      .parent(".accordion-item")
      .toggleClass("active")
      .siblings()
      .removeClass("active");
    $(this)
      .parent(".accordion-item")
      .find(".accordion-content")
      .stop(true, true)
      .slideToggle();
    $(this)
      .parent(".accordion-item")
      .prevAll(".accordion-item")
      .find(".accordion-content")
      .slideUp();
    $(this)
      .parent(".accordion-item")
      .nextAll(".accordion-item")
      .find(".accordion-content")
      .slideUp();
  });

  // inner-page-navbar
  const innerPageNavSlider = new Swiper(".inner-page-navbar .swiper", {
    slidesPerView: "auto",
  });

  // hero slider
  const heroSwiper = new Swiper(".hero-banner-section .swiper", {
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return `
                  <span class="${className}">
                    <svg viewBox="0 0 24 24" class="circle-ring">
                      <circle cx="12" cy="12" r="9" />
                    </svg>
                    <span class="dot"></span>
                  </span>
                `;
      },
    },
    speed: 1000,
    autoplay: {
      delay: 7500,
      disableOnInteraction: false,
    },
  });

  // relatedProducts carousel swiper
  const relatedProducts = document.querySelector(".product-carousel-swiper");
  if (relatedProducts) {
    const productCarouselSwiper = new Swiper(".product-carousel-swiper", {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 16,
      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      speed: 1000,
      navigation: {
        nextEl: ".product-carousel-swiper .swiper-button-next",
        prevEl: ".product-carousel-swiper .swiper-button-prev",
      },
    });
  }
  const bannerSlider = document.querySelector(".desk-swiper");
  if (bannerSlider) {
    const bannerSliderSwiper = new Swiper(".desk-swiper", {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      // breakpoints: {
      //     320: {
      //         slidesPerView: 1,
      //         spaceBetween: 16,
      //     },
      //     768: {
      //         slidesPerView: 1,
      //         spaceBetween: 20,
      //     },
      //     992: {
      //         slidesPerView: 1,
      //         spaceBetween: 40,
      //     },
      // },
      speed: 1000,
      autoplay: {
        delay: 7500,
        disableOnInteraction: false,
      },
    });
  }

  /*thumbnilslider  */
  const thumbnilslider = new Swiper(".thumbnilslider", {
    direction: "vertical", // vertical thumbnails
    slidesPerView: "auto",
    spaceBetween: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        direction: "horizontal",
        spaceBetween: 8,
      },
      768: {
        direction: "horizontal",
        spaceBetween: 1,
      },
      1024: {
        direction: "vertical",
        spaceBetween: 8,
      },
    },
  });

  const mainslider = new Swiper(".mainslider", {
    spaceBetween: 10,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 0,
    thumbs: {
      swiper: thumbnilslider,
    },
  });

  const thumbnilslider2 = new Swiper(".thumbnilslider2", {
    direction: "horizontal",
    slidesPerView: 5,
    spaceBetween: 8,

    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 8,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
    },
  });

  const productGallerySlider = new Swiper(".thumbnil-product-section", {
    spaceBetween: 10,
    effect: "fade",
    navigation: {
      nextEl: ".thumbnilslider2-outer-wrap .swiper-button-next",
      prevEl: ".thumbnilslider2-outer-wrap .swiper-button-prev",
    },
    fadeEffect: {
      crossFade: true,
    },
    speed: 0,
    thumbs: {
      swiper: thumbnilslider2,
    },
  });

  // select dropdown
  $(".select-wrapper select").on("mousedown focus", function () {
    $(this).closest(".select-wrapper").addClass("open");
  });

  $(".select-wrapper select").on("change blur", function () {
    $(this).closest(".select-wrapper").removeClass("open");
  });

  /* tab */
  $(".custom-tabs .tab").on("click", function (e) {
    e.preventDefault();
    // Block disabled tabs directly
    if ($(this).hasClass("disabled")) {
      return;
    }

    var tab_id = $(this).attr("data-tab");
    if ($(this).parents(".custom-filter-wrapper").length > 0) {
      if (window.innerWidth >= 1024) {
        if ($(this).hasClass("current")) {
          $(this).removeClass("current");
          $("#" + tab_id).removeClass("current");
          $(".tab-content-wrap .filter-btns").addClass("hide-filter-btns");
          $(".custom-filter-wrapper .custom-tabs .tab").removeClass("disabled");
        } else {
          $(".tab-content-wrap .filter-btns").removeClass("hide-filter-btns");
          $(".custom-tabs .tab").removeClass("current");
          $(".tab-content").removeClass("current");
          $(this).addClass("current");
          $("#" + tab_id).addClass("current");
        }
      }
    } else {
      if ($(this).hasClass("current")) {
        $(this).removeClass("current");
        $("#" + tab_id).removeClass("current");
      } else {
        $(".custom-tabs .tab").removeClass("current");
        $(".tab-content").removeClass("current");

        $(this).addClass("current");
        $("#" + tab_id).addClass("current");
      }
    }
  });

  /* table collapse */
  const collapseBtn1 = $(".specifications-section .collapse-btn");
  const showMoreBtn1 = $(".specifications-section .collapse-btn.show-more");
  const showLessBtn1 = $(".specifications-section .collapse-btn.show-less");
  showLessBtn1.hide();
  if (collapseBtn1.length) {
    const $visibletable = $(".table-wrapper .table-row");
    $visibletable.hide().slice(0, 4).show();
    collapseBtn1.on("click", function () {
      const parent = $(this).closest(".specifications-content-wrap");

      if (parent.hasClass("open-table")) {
        $(this).parent(".btn-wrap").find(collapseBtn1).hide();
        $(this).parent(".btn-wrap").find(showMoreBtn1).show();
        $visibletable.slice(4).slideUp(300);
        parent.removeClass("open-table");
      } else {
        $(this).parent(".btn-wrap").find(collapseBtn1).hide();
        $(this).parent(".btn-wrap").find(showLessBtn1).show();
        $visibletable.slice(4).slideDown(300);
        parent.addClass("open-table");
      }
    });
  }
  // content collapse & expand (feature-card-section)
  const collapseBtn = $(".feature-card-section .collapse-btn");
  const showMoreBtn = $(".feature-card-section .collapse-btn.show-more");
  const showLessBtn = $(".feature-card-section .collapse-btn.show-less");

  showLessBtn.hide();
  if (collapseBtn) {
    collapseBtn.on("click", function () {
      const parent = $(this).closest(".feature-card-content");
      parent.toggleClass("active");
      const content = parent.find(".text-collapse-block");
      if (content.is(":visible")) {
        $(this).parent(".btn-wrap").find(collapseBtn).hide();
        $(this).parent(".btn-wrap").find(showMoreBtn).show();
        content.slideUp();
      } else {
        $(this).parent(".btn-wrap").find(collapseBtn).hide();
        $(this).parent(".btn-wrap").find(showLessBtn).show();
        content.slideDown();
      }
    });
  }

  // Initialize card-trigger animation
  const cardTrigger = $(".card-trigger");
  if (cardTrigger) {
    $(this).each(function (item) {
      const svg = $(".card-trigger").find("svg");
      if (svg.length > 0) {
        function addAnimateClass() {
          if (!svg.hasClass("animate-circle")) {
            svg.addClass("animate-circle");
          } else {
            setTimeout(() => {
              svg.removeClass("animate-circle");
            }, 1500);
          }
        }
        addAnimateClass();
        setInterval(() => {
          addAnimateClass();
        }, 1500);
      }
    });
  }

  $(".all-product").each(function () {
    const $section = $(this);
    const $cards = $section.find(".product-list-card");
    const $moreBtn = $section.find(".more-product");

    $cards.hide().slice(0, 6).show();

    if ($cards.length <= 6) {
      $moreBtn.hide();
    }

    $moreBtn.click(function () {
      $cards.show(300);
      $(this).hide();
    });
  });

  /* sidbar */
  $(".sidebar li").on("click", function () {
    const target = $(this).data("target");
    const offsetTop = $(target).offset().top - 160;
    $("html, body").animate(
      {
        scrollTop: offsetTop >= 0 ? offsetTop : 0,
      },
      500
    );
  });

  /* card-trigger-modal-wrap */
  $(".card-trigger-modal-wrap .card-trigger").click(function (e) {
    e.stopPropagation();

    const $wrap = $(this).closest(".card-trigger-modal-wrap");
    const $modal = $wrap.find(".card-trigger-modal");

    $(".card-trigger-modal").not($modal).fadeOut(200);

    if ($modal.is(":visible")) {
      $modal.fadeOut(200);
    } else {
      positionModal($(this), $modal);
      $modal.fadeIn(200);
    }
  });

  $(document).click(function () {
    $(".card-trigger-modal").fadeOut(200);
  });

  $(".card-trigger-modal").click(function (e) {
    e.stopPropagation();
  });

  // Country selector modal
  if ($(".country-selector-modal").length > 0) {
    $(".country-selector-btn").on("click", function () {
      $(".country-selector-modal").toggleClass("open");
    });
    $(".country-selector-modal .close-btn").on("click", function () {
      $(".country-selector-modal").removeClass("open");
    });
  }

  $(".card-popup-modal .card-popup-modal-inner .close-btn").click(function () {
    $(".card-popup-modal").hide();
  });

  productrotation();
  zoomimg();
  contentanimation();
  updateActiveSection();
  initBadgeSwiper();
  setTimeout(initFeatureCardSwiperThreeCol, 10);
});

$(window).on("resize", function () {
  /* 20-02-26 announcement bar start */
  headerWithAnnoucementUnified();
  /* 20-02-26 announcement bar end */
  
  /* enumeration block updates start */
    eqHeight();
    /* enumeration block updates end */

  // for search-expand
  customSearchExpand();
  initBadgeSwiper();
  menuDropdown(); // for header
  initFeatureCardSwiper();
  setTimeout(initFeatureCardSwiperThreeCol, 10);

  if (window.innerWidth >= 1024) {
    $("body").removeClass("open-filter-drawer");
    $(".custom-filter-wrapper .tab-content").removeClass("active");
  } else {
    $(".custom-filter-wrapper .custom-tabs .tab").removeClass("disabled");
  }
});

$(window).scroll(function () {
  /* 20-02-26 announcement bar start */
  headerWithAnnoucementUnified();
  /* 20-02-26 announcement bar end */
  updateActiveSection();
});

$(window).on("scroll resize", function () {
  $(".card-trigger-modal:visible").each(function () {
    const $modal = $(this);
    const $wrap = $modal.closest(".card-trigger-modal-wrap");
    const $trigger = $wrap.find(".card-trigger");
    positionModal($trigger, $modal);
  });
});

// add class to body only the first time each individual page is visited
window.addEventListener("DOMContentLoaded", function () {
  const pageKey = "visited_" + window.location.pathname;

  if (!localStorage.getItem(pageKey)) {
    document.body.classList.add("first-load");
    localStorage.setItem(pageKey, "true");
  }
  initFeatureCardSwiper();
  setTimeout(initFeatureCardSwiperThreeCol, 10);
});

document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;
  const navLinks = document.querySelectorAll(
    ".inner-page-navbar .swiper-slide a"
  );

  let activeIndex = 0;

  navLinks.forEach((link, index) => {
    const linkPath = new URL(link.href).pathname;

    if (linkPath === currentPath) {
      link.classList.add("active"); // add active class for styling
      activeIndex = index;
    }
  });

  const innerPageNavSlider = new Swiper(".inner-page-navbar .swiper", {
    slidesPerView: "auto",
    initialSlide: activeIndex,
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".videoPlayer");

  videos.forEach((video) => {
    // Unmute when user presses play
    video.addEventListener("play", function () {
      video.muted = false;
    });
  });
});

window.addEventListener("message", (event) => {
  if (event.origin !== "https://klear.com") return;

  if (event.data && event.data.closeModal === true) {
    $(".consumer-ambassador-iframe").removeClass("active");
    $("body").removeClass("consumer-ambassador-iframe-open");
  }
});
